import { useAtomValue } from 'jotai'
import { metadataChannelAtom } from '@/atoms/invalidation'
import client from '@/services/client.service'
import { loadNostrUser, bareNostrUser, NostrUser } from '@nostr/gadgets/metadata'
import { useMemo } from 'react'
import { useCurrentProfile } from '@/atoms/profile'
import { resolveProfileInput } from '@/lib/pubkey'
import { useAsync } from 'react-use'

export function useFetchProfile(input?: string | NostrUser) {
  const currentAccountProfile = useCurrentProfile()
  const channel = useAtomValue(metadataChannelAtom)

  const fallback = useMemo(
    () => (input ? (typeof input === 'object' ? input : bareNostrUser(input)) : undefined),
    [input]
  )

  const {
    error,
    value: profile,
    loading: isFetching
  } = useAsync(async () => {
    if (!input) throw new Error('No input provided')
    if (typeof input === 'object') return input

    if (currentAccountProfile && fallback?.pubkey === currentAccountProfile.pubkey)
      return currentAccountProfile

    const req = await resolveProfileInput(input)
    const profile = await loadNostrUser(req)
    if (profile) {
      client.addUsernameToIndex(profile)
      return profile
    }
  }, [input, currentAccountProfile, channel])

  return { isFetching, error, profile: profile ?? fallback }
}
